import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Modal, Pagination, Select, Spin, Switch, Tooltip} from 'antd';
import {CheckOutlined, ClearOutlined, CloseOutlined, DeleteOutlined, DownloadOutlined, EditOutlined, InfoCircleOutlined} from '@ant-design/icons';
import moment from 'moment';
import schedule from '../../Actions/schedule'
import user from '../../Actions/user';
import Base from '../Base';
import {orderListByKey} from '../../helpers';
import GoogleDriveMessage from '../_Generic/GoogleDriveMessage';
import TableView from '../tableView';
import CustomSelect from '../_Generic/Select/CustomSelect';
import CheckBoxSelect from '../_Generic/Select/CheckBoxSelect';
import {pageGA} from '../../Helpers/GoogleAnalytics';
import VolumeButton from '../_Generic/VolumeButton';
import ModalEnhancedPlan from '../ModalEnhancedPlan';
import CFDITypes from "../../Catalogs/tipoComprobante.json";
import CFDIComplements from "../../Catalogs/complements.json";
import EachDaysCatalog from "../../Catalogs/eachDaysCatalog.json";
import LapseDaysCatalog from "../../Catalogs/lapseDaysCatalog.json";
import RoleHelper from "../../Helpers/RoleHelper";
import EditScheduleModal from './EditScheduleModal';

const {setScheduleProperty, saveSchedule, updateScheduleStatus, searchSchedule, setScheduleFilters,
    updateScheduleConfig, removeScheduleConfig, exportScheduleConfigs} = schedule.actions
const {getUserData, getRoleData} = user.actions;

const DEFAULT_ALL_SELECT_OPTION = {
    'label': "Todos",
    'value': null,
    'disabled': false
}

const DEFAULT_TABLE_LABEL = "Todos";

class Schedule extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModalEnhancement: false,
            editingRow: null
        }
    }

    componentDidMount() {
        let queryCertificates = {
            ...this.props.certificatesPagination,
            page: 1,
            perPage: 50
        }
        let querySchedules = {
            ...this.props.schedulePagination,
            page: 1,
            perPage: 5
        }
        this.props.getUserData(queryCertificates);
        this.props.getRoleData();
        this.props.searchSchedule(querySchedules);
        pageGA();

    }

    componentWillUnmount() {
        clearTimeout(this.searchDebounceTimer);
    }
    render() {
        const {isUserLoading, gDriveData, email, isFreePlan, taxpayerVolume, roleHelper, schedule} = this.props;
        const {generatePdf, googleDrive, includeCancellationDate, processType} = this.props.schedule;
        const {page, perPage, totalCount} = this.props.schedulePagination;
        
        console.log(schedule);
        return (<Base>
            <h1 className='title-text blue-text'>Programador Descargas</h1>
            <p className='label'> Aquí podras programar tus descargas por día, por semana o mes para evitar que lo
                realices manualmente, solo selecciona los parámetros que deseas para programar tu descarga de
                comprobantes.</p>
            {gDriveData.name === '' && <GoogleDriveMessage/>}
            <div className='filters-container' style={{marginTop: '20px'}}>
                <div className='input-container'>
                    <label htmlFor='' className='label block'>Frecuencia:</label>
                    <CustomSelect
                        defaultValue={this.props.schedule.frequencyInDays}
                        value={this.props.schedule.frequencyInDays}
                        style={{width: 170}}
                        onChange={this.handleFrequency}
                        loading={isUserLoading}
                        items={this.selectDays()}
                    />
                </div>
                <div className='input-container'>
                    <label htmlFor='' className='label block'>Rango:</label>
                    <CustomSelect
                        defaultValue={this.props.schedule.lapseDays}
                        value={this.props.schedule.lapseDays}
                        style={{width: 170}}
                        onChange={this.handleRange}
                        loading={isUserLoading}
                        items={this.selectLapseDays()}
                    />
                </div>
                <div className='input-container'>
                    <label htmlFor='' className='label block'>RFC de descarga:</label>
                    <CheckBoxSelect
                        taxpayerVolume={taxpayerVolume}
                        loading={isUserLoading}
                        handleChage={this.handleChangeTaxId.bind(this)}
                        items={orderListByKey(this.props.userData, "taxId").map(element => element.taxId)}
                    />
                </div>
                <div className='input-container'>
                    <label htmlFor='' className='label block'>Tipo de solicitud:</label>
                    <CustomSelect
                        key={`processType-${isFreePlan}`}
                        defaultValue={this.props.schedule.processType}
                        value={this.props.schedule.processType}
                        style={{width: 170}}
                        onChange={this.handleProcessType}
                        loading={isUserLoading}
                        items={this.selectTipo(isFreePlan)}
                    />
                </div>
                <div className='input-container'>
                    <label htmlFor='' className='label block'>Documentos:</label>
                    <CustomSelect
                        defaultValue={this.props.schedule.documentType}
                        value={this.props.schedule.documentType}
                        style={{width: 170}}
                        onChange={this.handleDocType}
                        loading={isUserLoading}
                        items={this.selectdocumentType(roleHelper)}
                    />
                </div>
            </div>
            <div className='filters-container' style={{maxWidth: "633px"}}>
                <div className="input-container">
                    <label htmlFor="" className="label block">Estado</label>
                    <CustomSelect
                        disabled={!this.isCFDIStatusEditable(this.props.schedule.processType, this.props.schedule.documentType)}
                        defaultValue={'Vigente'}
                        value={this.props.schedule.cfdiStatus}
                        onChange={this.handleCFDIStatus}
                        style={{width: 170}}
                        items={this.selectCFDIStatus()}
                    />
                </div>
                <div className="input-container">
                    <label htmlFor="" className="label block">Tipo</label>
                    <CustomSelect
                        value={this.props.schedule.cfdiType}
                        style={{width: 170}}
                        onChange={this.handleCFDIType}
                        items={this.selectCFDIType(roleHelper, schedule.documentType)}
                        disabled={this.props.schedule.processType == 1}
                    />
                </div>
                <div className="input-container">
                    <label htmlFor="" className="label block">Complemento</label>
                    <CustomSelect
                        value={this.props.schedule.cfdiComplement}
                        style={{width: 170}}
                        onChange={this.handleCFDIComplement}
                        items={this.selectCFDIComplement()}
                        disabled={this.props.schedule.processType == 1}
                    />
                </div>
            </div>
            <div className='extras-container' style={{maxWidth: "550px", marginLeft: "auto"}}>
                <div className="input-container-inline" style={{display: 'flex', alignItems: 'center'}}>
                    <Switch
                        onChange={this.handleSwitch.bind(this, 'generatePdf')}
                        checkedChildren={<CheckOutlined/>}
                        unCheckedChildren={<CloseOutlined/>}
                        checked={generatePdf}
                        style={{width: '50px', margin: 'auto'}}
                    />
                    <label htmlFor="" className="label block" style={{marginLeft: '5px'}}>Generar Facturas PDF</label>
                </div>
                <div className="input-container-inline" style={{display: 'flex', alignItems: 'center'}}>
                    <Switch
                        onChange={this.handleSwitch.bind(this, 'googleDrive')}
                        checkedChildren={<CheckOutlined/>}
                        unCheckedChildren={<CloseOutlined/>}
                        checked={googleDrive}
                        disabled={gDriveData.name === ''}
                        style={{width: '50px', margin: 'auto'}}
                    />
                    <label htmlFor="" className="label block" style={{marginLeft: '5px'}}>Google Drive</label>
                </div>
                <div className="input-container-inline" style={{display: 'flex', alignItems: 'center'}}>
                    <Switch
                        onChange={this.handleSwitch.bind(this, 'includeCancellationDate')}
                        checkedChildren={<CheckOutlined/>}
                        unCheckedChildren={<CloseOutlined/>}
                        checked={includeCancellationDate === true}
                        disabled={String(processType) !== '0'}
                        style={{width: '50px', margin: 'auto'}}
                    />
                    <label htmlFor="" className="label block" style={{marginLeft: '5px'}}>Incluir fecha de cancelación</label>
                    <Tooltip title="La descarga tarda más porque se solicita al SAT la información de cancelación. Sin esta opción el reporte incluye el estatus (vigente/cancelado) pero no la fecha de cancelación.">
                        <InfoCircleOutlined style={{marginLeft: '5px', color: '#8c8c8c'}}/>
                    </Tooltip>
                </div>
                <div className='actions-container'>
                    <VolumeButton taxId={this.props.schedule.taxId} onClick={this.generateScheduleRequest}
                                  label='Programar Descarga'/>
                </div>
            </div>
            <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '20px', marginBottom: '10px'}}>
                <Button icon={<ClearOutlined/>} onClick={this.clearFilters} style={{marginRight: '10px'}}>
                    Limpiar filtros
                </Button>
                <Button type='primary' icon={<DownloadOutlined/>} onClick={this.exportConfigs}>
                    Descargas configuraciones
                </Button>
            </div>
            {/* schedule-table: celdas compactas para que las 9 columnas quepan
                en pantalla sin scroll; en pantallas chicas hace scroll interno
                en vez de ensanchar la página (comprime el sidebar). */}
            <TableView loading={this.props.tableLoading} columns={this.columns()}
                       data={this.props.scheduleConfigs.records}
                       className='schedule-table'/>
            <Pagination
                total={totalCount}
                showTotal={total => `Total ${total}  registros`}
                pageSize={perPage}
                defaultCurrent={1}
                current={page}
                showSizeChanger={false}
                onChange={this.paginate}
            />
            {(!this.props.tableLoading && this.props.isLoading) &&
                <div className='loading-container'>
                    <Spin size='large' tip='Cargando'/>
                </div>
            }
            <ModalEnhancedPlan
                showModal={this.state.showModalEnhancement}
                email={email}
                onClick={this.closeModal.bind(this)}
            />
            <EditScheduleModal
                visible={this.state.editingRow !== null}
                row={this.state.editingRow}
                isFreePlan={isFreePlan}
                gDriveDisabled={gDriveData.name === ''}
                roleHelper={roleHelper}
                onCancel={this.closeEditModal}
                onSave={this.handleSaveEdit}
            />
        </Base>)
    }

    handleSwitch(key, value) {
        const {isFreePlan} = this.props;
        if (key === 'generatePdf' && isFreePlan) {
            this.setState({showModalEnhancement: true});
            return;
        }

        this.props.setScheduleProperty({[key]: value});
    }

    closeModal(value) {
        this.setState({showModalEnhancement: value});
    }

    handleChangeTaxId = (value) => {
        this.props.setScheduleProperty({taxId: value});
    }
    handleFrequency = (value) => {

        this.props.setScheduleProperty({frequencyInDays: value});
    }
    handleRange = (value) => {
        this.props.setScheduleProperty({lapseDays: value});
    }
    handleDocType = (value) => {
        this.props.setScheduleProperty({documentType: value});
        // En XML de Recepción el SAT solo permite vigentes.
        if (!this.isCFDIStatusEditable(this.props.schedule.processType, value)) {
            this.props.setScheduleProperty({cfdiStatus: 'Vigente'});
        }
    }
    handleCFDIType = (value) => {
        this.props.setScheduleProperty({cfdiType: value});
    }
    handleCFDIComplement = (value) => {
        this.props.setScheduleProperty({cfdiComplement: value});
    }
    handleProcessType = (value) => {
        this.props.setScheduleProperty({processType: value});

        // La fecha de cancelación solo aplica a Descarga XML (0).
        if (value != 0) {
            this.props.setScheduleProperty({includeCancellationDate: false});
        }

        // If Portal del SAT is selected (value 1), reset cfdiType and cfdiComplement to null
        if (value == 1) {
            this.handleCFDIType(null);
            this.handleCFDIComplement(null);
        }
        // El estatus solo aplica a XML Emisión y Metadata; en el resto se fuerza Vigente.
        if (!this.isCFDIStatusEditable(value, this.props.schedule.documentType)) {
            this.props.setScheduleProperty({cfdiStatus: 'Vigente'});
        }
    }
    isCFDIStatusEditable = (processType, documentType) => {
        // El estatus (EstadoComprobante) solo se envía al SAT en XML (0 y 3) y Metadata (2).
        if (processType != 0 && processType != 2 && processType != 3) return false;
        // En XML de Recepción el SAT solo permite vigentes.
        if ((processType == 0 || processType == 3) && documentType == 1) return false;
        return true;
    }
    handleCFDIStatus = (value) => {
        this.props.setScheduleProperty({cfdiStatus: value});
    }
    // --- Filtros de la tabla ---
    searchWithFilters = (page) => {
        // Cancela cualquier búsqueda debounced pendiente para no duplicar peticiones.
        clearTimeout(this.searchDebounceTimer);
        const {perPage} = this.props.schedulePagination;
        this.props.searchSchedule({page, perPage});
    }

    // Agrupa cambios rápidos de filtros (p. ej. seleccionar varios RFCs seguidos)
    // en una sola petición al API/BD.
    debouncedSearch = () => {
        clearTimeout(this.searchDebounceTimer);
        this.searchDebounceTimer = setTimeout(() => this.searchWithFilters(1), 450);
    }

    handleFilterChange = (key, value) => {
        let normalized = value === undefined ? null : value;
        if (key === 'taxIds')
            normalized = normalized || [];
        // Si el valor no cambió, no hay nada que buscar.
        const current = this.props.scheduleFilters[key];
        if (key === 'taxIds'
            ? JSON.stringify(current || []) === JSON.stringify(normalized)
            : current === normalized)
            return;
        this.props.setScheduleFilters({[key]: normalized});
        this.debouncedSearch();
    }

    hasActiveFilters = () => {
        const f = this.props.scheduleFilters;
        return (f.taxIds && f.taxIds.length > 0)
            || f.documentType !== null
            || f.processType !== null
            || f.frequencyInDays !== null
            || f.cfdiType !== null
            || f.cfdiComplement !== null
            || f.active !== null;
    }

    clearFilters = () => {
        // Sin filtros activos no hay nada que limpiar ni re-consultar.
        if (!this.hasActiveFilters())
            return;
        this.props.setScheduleFilters({
            taxIds: [],
            documentType: null,
            processType: null,
            frequencyInDays: null,
            cfdiType: null,
            cfdiComplement: null,
            active: null
        });
        this.searchWithFilters(1);
    }

    exportConfigs = () => {
        this.props.exportScheduleConfigs();
    }

    // Altura uniforme para todos los encabezados: etiqueta arriba, filtro abajo.
    // Las columnas sin filtro reciben un espaciador para quedar al mismo nivel.
    filterTitle = (label, control = null) => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: '58px'
            }}>
                <div style={{marginBottom: '4px'}}>{label}</div>
                {control || <div style={{height: '24px'}}/>}
            </div>
        );
    }

    filterSelect = (filterKey, items, extraProps = {}) => {
        const {scheduleFilters} = this.props;
        // 'Todos' (value null) limpia el filtro, igual que los combobox del
        // formulario. En modo múltiple (RFC) no aplica: sin selección = todos.
        const options = extraProps.mode === 'multiple'
            ? items
            : [{...DEFAULT_ALL_SELECT_OPTION, key: 'todos'}, ...items];
        return (
            <CustomSelect
                allowClear
                placeholder='Todos'
                size='small'
                style={{width: '100%', minWidth: '85px'}}
                value={scheduleFilters[filterKey]}
                onChange={(value) => this.handleFilterChange(filterKey, value)}
                items={options}
            {...extraProps}
            />
        );
    }

    // --- Acciones editar / eliminar ---
    openEditModal = (row) => {
        this.setState({editingRow: row});
    }

    closeEditModal = () => {
        this.setState({editingRow: null});
    }

    handleSaveEdit = (changes) => {
        const row = this.state.editingRow;
        this.props.updateScheduleConfig({
            taxId: row.taxId,
            documentType: row.documentType,
            processType: row.processType,
            changes
        });
        this.closeEditModal();
    }

    confirmRemove = (row) => {
        Modal.confirm({
            title: '¿Eliminar descarga programada?',
            content: `Se eliminará la configuración del RFC ${row.taxId.toUpperCase()} (${this.documentParser(row.documentType)} / ${this.requestParser(row.processType)}). Esta acción no se puede deshacer.`,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk: () => {
                this.props.removeScheduleConfig({
                    taxId: row.taxId,
                    documentType: row.documentType,
                    processType: row.processType
                });
            }
        });
    }

    handleChangeStatus = (row, estatus, index) => {
        row.active = estatus ? 1 : 0
        let payload = {
            row,
            index
        }
        this.props.updateScheduleStatus(payload)
    }

    selectDays = () => {
        return EachDaysCatalog.map(d => ({
            'label': d.label,
            'key': d.key,
            'value': d.key,
            'disabled': false
        }));
    }
    selectLapseDays = () => {
        return LapseDaysCatalog.map(ct => ({
            'label': ct.label,
            'key': ct.key,
            'value': ct.key,
            'disabled': false
        }));
    }

    selectTipo = (isFreePlan) => {
        return [
            {key: '0', value: '0', label: 'Descarga XML'},
            {key: '1', value: '1', label: 'Portal del SAT', disabled: isFreePlan},
            {key: '2', value: '2', label: 'Validación EFOS', disabled: isFreePlan}
        ]
    }
    selectdocumentType = (roleHelper) => {
        return [
            {key: '0', value: '0', label: 'Emisión', disabled: !roleHelper.hasAccess(RoleHelper.ACTION_SCHEDULE,RoleHelper.DOCUMENT_TYPE_EMITIDOS)},
            {key: '1', value: '1', label: 'Recepción', disabled: !roleHelper.hasAccess(RoleHelper.ACTION_SCHEDULE,RoleHelper.DOCUMENT_TYPE_RECIBIDOS)}
        ]
    }
    selectCFDIStatus = () => {
        return [
            {label: 'Vigente', key: 'Vigente', value: 'Vigente', disabled: false},
            {label: 'Cancelado', key: 'Cancelado', value: 'Cancelado', disabled: false},
            {label: 'Todos', key: 'Todos', value: 'Todos', disabled: false}
        ];
    }
    selectCFDIType = (roleHelper, documentType) => {
        const documentTypeDict = {
            "0": "emision",
            "1": "recepcion"
        }
        return [
            {...DEFAULT_ALL_SELECT_OPTION,
                disabled: !roleHelper.hasAllOptions(RoleHelper.ACTION_SCHEDULE,documentTypeDict[documentType])
            },
            ...CFDITypes.map(ct => ({
                'label': ct.label,
                'key': ct.key,
                'value': ct.key,
                'disabled': !roleHelper.hasAccess(RoleHelper.ACTION_SCHEDULE,documentTypeDict[documentType],ct.key),
            }))
        ]
    }

    selectCFDIComplement = () => {
        return [
            DEFAULT_ALL_SELECT_OPTION,
            ...CFDIComplements.map(ct => ({
                'label': ct.label,
                'key': ct.key,
                'value': ct.key,
                'disabled': false
            }))
        ]
    }

    documentParser(doc) {
        switch (doc) {
            case 0:
                return 'Emisión';
            case 1:
                return 'Recepción';
            default:
                return 'Emisión'
        }
    }

    requestParser(req) {
        switch (req) {
            case 0:
                return 'Descarga XML';
            case 1:
                return 'Portal del SAT';
            case 2:
                return 'Validación EFOS';
            case 3:
                return 'Descarga XML con fecha de cancelación';
            default:
                return 'N/A'
        }
    }

    typeParser(val) {
        const cfdiType = CFDITypes.find(t => val === t.key);
        return cfdiType ? cfdiType.label : DEFAULT_TABLE_LABEL;
    }

    complementParser(val) {
        const cfdiComplement = CFDIComplements.find(t => val === t.key);
        return cfdiComplement ? cfdiComplement.label : DEFAULT_TABLE_LABEL;
    }

    generateScheduleRequest = () => {
        // processType es el requestType; OnlyCfdi (3) pide metadata real (estatus + fecha de cancelación).
        const payload = {...this.props.schedule};
        if (payload.includeCancellationDate === true && String(payload.processType) === '0') {
            payload.processType = '3';
        }
        this.props.saveSchedule(payload)
    }

    columns() {
        const taxIdItems = orderListByKey(this.props.userData, "taxId").map(element => ({
            'label': element.taxId,
            'key': element.taxId,
            'value': element.taxId,
            'disabled': false
        }));
        const documentTypeItems = [
            {key: '0', value: '0', label: 'Emisión'},
            {key: '1', value: '1', label: 'Recepción'}
        ];
        const processTypeItems = [
            {key: '0', value: '0', label: 'Descarga XML'},
            {key: '1', value: '1', label: 'Portal del SAT'},
            {key: '2', value: '2', label: 'Validación EFOS'}
        ];
        const cfdiTypeItems = CFDITypes.map(ct => ({
            'label': ct.label, 'key': ct.key, 'value': ct.key, 'disabled': false
        }));
        const cfdiComplementItems = CFDIComplements.map(ct => ({
            'label': ct.label, 'key': ct.key, 'value': ct.key, 'disabled': false
        }));
        const activeItems = [
            {key: '1', value: '1', label: 'Activo'},
            {key: '0', value: '0', label: 'Inactivo'}
        ];
        return [
            {
                title: this.filterTitle('Última Ejecución'),
                key: 'visited',
                render: (tex, row) => (
                    <span>{row.visited === '0001-01-01T00:00:00' ? 'Sin ejecutar' : moment(row.visited).format('DD-MM-YYYY HH:mm')}</span>
                )
            },
            {
                title: this.filterTitle('RFC', this.filterSelect('taxIds', taxIdItems, {
                    mode: 'multiple',
                    maxTagCount: 1,
                    style: {width: '100%', minWidth: '110px'}
                })),
                key: 'taxId',
                render: (tex, row) => (
                    <span>{row.taxId.toUpperCase()}</span>
                )
            },
            {
                title: this.filterTitle('Recurrencia', this.filterSelect('frequencyInDays', this.selectDays())),
                key: 'frequencyInDays',
                render: (tex, row) => (
                    <span>Cada {row.frequencyInDays} dias</span>
                )
            },
            {
                title: this.filterTitle('Tipo de documentos', this.filterSelect('documentType', documentTypeItems)),
                dataIndex: 'documentType',
                render: (tex, row) => (
                    <span>{this.documentParser(row.documentType)}</span>
                )
            },
            {
                title: this.filterTitle('Tipo de solicitud', this.filterSelect('processType', processTypeItems)),
                dataIndex: 'processType',
                render: (tex, row) => (
                    <span>{this.requestParser(row.processType)}</span>
                )
            },
            {
                title: this.filterTitle('Tipo', this.filterSelect('cfdiType', cfdiTypeItems)),
                dataIndex: 'cfdiType',
                render: (tex, row) => (
                    <span>{this.typeParser(row.cfdiType)}</span>
                )
            },
            {
                title: this.filterTitle('Complemento', this.filterSelect('cfdiComplement', cfdiComplementItems)),
                dataIndex: 'cfdiComplement',
                render: (tex, row) => (
                    <span>{this.complementParser(row.cfdiComplement)}</span>
                )
            },
            {
                title: this.filterTitle('Estatus', this.filterSelect('active', activeItems)),
                key: 'active',
                render: (tex, row, index) => (
                    <span><Switch
                        onChange={(value) => {
                            this.handleChangeStatus(row, value, index)
                        }}
                        checkedChildren={<CheckOutlined/>}
                        unCheckedChildren={<CloseOutlined/>}
                        checked={row.active === 1}
                        style={{width: '50px', margin: 'auto'}}
                    /></span>
                )
            },
            {
                title: this.filterTitle('Acciones'),
                key: 'actions',
                render: (tex, row) => (
                    <span style={{whiteSpace: 'nowrap'}}>
                        <Tooltip title='Editar'>
                            <Button type='link' icon={<EditOutlined/>} onClick={() => this.openEditModal(row)}/>
                        </Tooltip>
                        <Tooltip title='Eliminar'>
                            <Button type='link' danger icon={<DeleteOutlined/>} onClick={() => this.confirmRemove(row)}/>
                        </Tooltip>
                    </span>
                )
            }
        ];
    }

    paginate = (page) => {
        this.searchWithFilters(page);
    }

}

const mapStateToProps = state => {
    let tableLoader = state._genericComponents.loading.find('tableLoading');
    let userDataLoader = state._genericComponents.loading.find('userLoading');
    const roleHelper = new RoleHelper(state.user.role);
    
    return {
        downloadXmls: state.gestionXml.downloadXmls,
        userData: state.user.userData,
        tableLoading: tableLoader ? tableLoader.isLoading : false,
        isLoading: state._genericComponents.loading.isCurrentlyLoading,
        isUserLoading: userDataLoader ? userDataLoader.isLoading : false,
        taxpayerVolume: state.taxpayer.taxpayerVolume,
        schedule: state.schedule.scheduleRequest,
        scheduleConfigs: state.schedule.scheduleConfigs,
        schedulePagination: state.schedule.schedulePagination,
        scheduleFilters: state.schedule.scheduleFilters,
        gDriveData: state.googleDrive.data,
        isFreePlan: state.license.isFreePlan,
        email: Object.keys(state.login.login).length > 0 ? state.login.login.values.username : state.register.registerData.email,
        roleHelper
    };

};

const mapDispatchToProps = dispatch => {
    return {
        setScheduleProperty(data) {
            dispatch(setScheduleProperty(data))
        },
        getUserData(query) {
            dispatch(getUserData(query));
        },
        getRoleData() {
            dispatch(getRoleData());
        },
        saveSchedule(body) {
            dispatch(saveSchedule(body))
        },
        searchSchedule(query) {
            dispatch(searchSchedule(query))
        },
        setScheduleFilters(filters) {
            dispatch(setScheduleFilters(filters))
        },
        updateScheduleStatus(data) {
            dispatch(updateScheduleStatus(data))
        },
        updateScheduleConfig(payload) {
            dispatch(updateScheduleConfig(payload))
        },
        removeScheduleConfig(payload) {
            dispatch(removeScheduleConfig(payload))
        },
        exportScheduleConfigs() {
            dispatch(exportScheduleConfigs())
        }
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);